<template>
  <div class="otc-timer txt--on-one-row">
    <span v-if="!(isShort && days < 1)" class="otc-timer__number">
      {{ days > 9 ? days : `0${days}` }}&nbsp;:&nbsp;
      <span
        v-if="!hideDescription"
        class="otc-timer__name txt--10px txt--weight-400"
      >
        {{ $t('common.timer.days') }}
      </span>
    </span>
    <span v-if="!(isShort && hours < 1)" class="otc-timer__number">
      {{ hours > 9 ? hours : `0${hours}` }}&nbsp;:&nbsp;
      <span
        v-if="!hideDescription"
        class="otc-timer__name txt--10px txt--weight-400"
      >
        {{ $t('common.timer.hours') }}
      </span>
    </span>
    <span class="otc-timer__number">
      {{ minutes > 9 ? minutes : `0${minutes}` }}
      <span
        v-if="!hideDescription"
        class="otc-timer__name txt--10px txt--weight-400"
      >
        {{ $t('common.timer.min') }}
      </span>
    </span>
    <span v-if="!hideSeconds" class="otc-timer__number">
      : {{ seconds > 9 ? seconds : ` 0${seconds}` }}
      <span
        v-if="!hideDescription"
        class="otc-timer__name txt--10px txt--weight-400"
      >
        {{ $t('common.timer.sec') }}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'TimerBlock',
  props: {
    endDate: {
      type: Date,
      required: true,
    },
    isShort: { type: Boolean, default: false },
    hideDescription: { type: Boolean, default: false },
    hideSeconds: { type: Boolean, default: false },
  },
  data () {
    return {
      msLeft: 0,
      timer: null,
    }
  },
  computed: {
    days () {
      const d = Math.floor(this.msLeft / (24 * 60 * 60 * 1000))
      return d > 0 ? d : 0
    },
    hours () {
      const daysMs = this.msLeft % (24 * 60 * 60 * 1000)
      const hours = Math.floor(daysMs / (60 * 60 * 1000))
      return hours > 0 ? hours : 0
    },
    minutes () {
      const hoursMs = this.msLeft % (60 * 60 * 1000)
      const min = Math.floor(hoursMs / (60 * 1000))
      return min > 0 ? min : 0
    },
    seconds () {
      const minutesMs = this.msLeft % (60 * 1000)
      const sec = Math.floor(minutesMs / 1000)
      return sec > 0 ? sec : 0
    },
  },
  watch: {
    msLeft (time) {
      if (time <= 0) {
        clearInterval(this.timer)
        this.$emit('stop')
      }
    },
    endDate (v, oldV) {
      if (v && oldV && v.getTime() === oldV.getTime()) return
      clearInterval(this.timer)

      this.startTimer()
    },
  },
  mounted () {
    this.startTimer()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    startTimer () {
      if (!process.client) return

      this.msLeft = this.endDate.getTime() - Date.now()
      this.timer = setInterval(() => {
        this.msLeft = this.endDate.getTime() - Date.now()
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.otc-timer {
  &__number {
    position: relative;
  }

  &__name {
    position: absolute;
    top: 100%;
    left: 0;
  }
}
</style>
